import { Component } from '@angular/core';
import { LoadingComponent } from '../../shared/skeleton-loader/widgets/loading/loading.component';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { CommonService } from '../../shared/services/common.service';
import { EntityService } from '../../services/entity.service';
import { SeoService } from '../../services/seo.service';

@Component({
  selector: 'app-read-video',
  standalone: true,
  imports: [LoadingComponent, RouterLink],
  templateUrl: './read-video.component.html',
  styleUrl: './read-video.component.scss'
})
export class ReadVideoComponent {
  public carouselContent = [
    {
      title: "Connectez-vous avec vos Stars Préférées",
      image: '/assets/images/bg-1.jpg'
    },
    {
      title: "Des Dédicaces Uniques et Personnalisées",
      image: '/assets/images/bg-2.jpg'
    },
    {
      title: "Paiement Sécurisé, Souvenirs Garantis",
      image: '/assets/images/bg-3.jpg'
    }
  ];

  public currentImageIndex = 0;
  public isTextVisible = true;
  public videoId: number;
  public video: any;

  constructor(private seoService: SeoService, private route: ActivatedRoute, private router: Router, private entityService: EntityService) {
    setInterval(() => {
      this.isTextVisible = false;
      setTimeout(() => {
        this.currentImageIndex = (this.currentImageIndex + 1) % this.carouselContent.length;
        this.isTextVisible = true;
      }, 500);
    }, 3000);
  }

  ngOnInit(): void {
    this.videoId = Number(this.route.snapshot.paramMap.get('id'));
    this.entityService.getDataById('/videos', this.videoId).subscribe((data: any) => {
      if (data) {
        this.video = data.data;
        const celebrity = this.video?.celebrity_name || 'une célébrité';
        const recipient = this.video?.recipient_name || '';
        const thumbnail = this.video?.thumbnail || 'https://yokastar.com/assets/images/logo-2.png';

        this.seoService.updateSeo({
          title: `Vidéo dédicacée de ${celebrity}${recipient ? ` pour ${recipient}` : ''}`,
          description: `Découvrez cette vidéo dédicacée exclusive de ${celebrity} sur YokaStar. Un message personnalisé unique !`,
          keywords: `vidéo dédicacée, ${celebrity}, YokaStar, message personnalisé`,
          image: thumbnail,
          url: `https://yokastar.com${this.router.url}`,
          type: 'video.other',
          twitterCard: 'player'
        });
      }
    });
  }

  ngOnDestroy(): void {
    this.seoService.resetToDefault();
  }
}
